import React from 'react'
import PropTypes from 'prop-types'
import ShowMore from 'Layout/ShowMore'
import PreconCard from '../PreconCard'

const PreconList = ({ listings }) => {
  if(!listings) return null
  const listingList = listings?.map((eachListing) => (<PreconCard listing={eachListing} />))
  return (
    <ShowMore
      buttonText={'Show More Listings'}
      minShow={6}
      elements={listingList}
      className="preconShowMore"
    />
  )
}
PreconList.propTypes = {
  listings: PropTypes.arrayOf(PropTypes.shape({})),
}

export default PreconList
